import {put} from 'redux-saga/effects';
import actions from '../../systemnotifications/actionCreators';

function* addSystemNotification(errorCode) {
  yield put(actions.addNotification(errorCode));
}

export default addSystemNotification;
